import Vue from 'vue'
import Vuex from 'vuex'
import { db } from '../db'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    picks: null,
    teams: null,
    status: 0,
    user: null,
    snackbar: false,
    test: 0,
  },
  getters: {
    picks(state) {
      return state.picks
    },
    teams(state) {
      return state.teams
    },
    status(state) {
      return state.status
    },
    user(state) {
      return state.user
    },
    snackbar(state) {
      return state.snackbar
    },
    test(state) {
      return state.test
    }
  },
  mutations: {
    SET_PICKS (state, payload) {
      state.picks = payload
    },
    CLEAR_PICKS (state) { 
      state.picks = null
    },
    PUSH_PICK (state, payload) {
      state.picks.push(payload)
      db.collection('data').doc('2021').update({picks: state.picks})
    },
    DELETE_PICK (state, payload) {
      state.picks.forEach((p, i) => {
        if (p.uid == payload.uid && p.timestamp == payload.ts) {
          state.picks.splice(i, 1)
        }
      })
      db.collection('data').doc('2021').update({picks: state.picks})
    },
    SET_TEAMS(state, payload) {
      state.teams = payload
    },
    SET_STATUS(state, payload) {
      state.status = payload
    },
    SET_USER(state, payload) {
      state.user = payload
    },
    SET_SNACK(state, payload) {
      state.snackbar = payload
    },
    SET_TEST(state, payload) {
      state.test = payload
      db.collection('data').doc('test').update({status: state.test})
    },
    CLEAR_SNACK(state) {
      state.snackbar = false
    },
    UPDATE_TEAM_ROUND(state, payload) {
      state.teams[payload.rKey][payload.tKey].round += payload.num
    },
    UPDATE_TEAM_ELIM(state, payload) {
      state.teams[payload.rKey][payload.tKey].elim = !state.teams[payload.rKey][payload.tKey].elim
    }
  },
  actions: {
    setPicks ({ commit }, payload) {
      commit('SET_PICKS', payload)
    },
    clearPicks({ commit }) {
      commit('CLEAR_PICKS')
    },
    pushPick ( { commit }, payload) {
      commit('PUSH_PICK', payload)
    },
    deletePick ( { commit }, payload) {
      commit('DELETE_PICK', payload)
    },
    setTeams({commit}, payload) {
      commit('SET_TEAMS', payload)
    },
    setStatus({commit}, payload) {
      commit('SET_STATUS', payload)
    },
    setUser({commit}, payload) {
      commit('SET_USER', payload)
    },
    setSnack({commit}, payload) {
      commit('SET_SNACK', payload)
    },
    setTest({commit}, payload) {
      commit('SET_TEST', payload)
    },
    clearSnack({commit}) {
      commit('CLEAR_SNACK')
    },
    updateTeamRound({commit}, payload) {
      commit('UPDATE_TEAM_ROUND', payload)
    },
    updateTeamElim({commit}, payload) {
      commit('UPDATE_TEAM_ELIM', payload)
    }
  },
  modules: {
    
  }
})
